import ManageRecurringTransfers from '../../../banking/components/transfers/recurring/manage/ManageRecurringTransfers';

const ManageRecurringTransfersPage = () => {
    return <ManageRecurringTransfers />;
};

export default ManageRecurringTransfersPage;
